import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import PANValidationModalUI from './PANValidationModalUI.js'

class PANValidationModalSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            successMsg: null,
            errorList: null,
            response: null,
            submitted: false,
            pan: '',
            panError: null,
        }
    }

    render() {
        return (
            <PANValidationModalUI
                context={this.props.context}
                errorList={this.state.errorList}
                successMsg={this.state.successMsg}
                setErrorList={this.setErrorList}
                response={this.state.response}
                submitted={this.state.submitted}
                onSubmit={this.onSubmit}
                updateMode={this.props.updateMode}
                onCancelClick={this.props.onCancelClick}
                pan={this.state.pan}
                onPanChange={(event) => { this.setState({ pan: event.target.value.toUpperCase() }) }}
                panError={this.state.panError}
                setPanError={(error) => { this.setState({ panError: error }) }}
            />
        )
    }

    componentDidMount() {
        Modal.setAppElement('body')
    }

    onSubmit = () => {
        if (this.state.submitted) return

        this.setState({
            successMsg: null,
            errorList: [],
            submitted: true
        })

        RestApiUtils.post(this.props.context,
            `/api/su/util/accounts/${this.props.account.accountId}/businessPAN/validation`,
            this.onSubmitCallback,
            {
                accountId: this.props.account.accountId,
                panNumber: this.state.pan
            }
        )
    }

    onSubmitCallback = (response) => {
        let errorList = [];
        console.log("jj");
        
        response.errorList.forEach(error => {
            errorList.push(error.message);
        });
    
        this.setState({
            successMsg: response.success,
            errorList: errorList,
            submitted: false
        });
    
        if (response.errorList.length === 0) {
            setTimeout(() => {
                this.setState({ successMsg: null });
                this.props.onCancelClick();
            }, 2000);
        }
    }
    
    setErrorList = (errorList) => {
        this.setState({ errorList: errorList });
    }
    
}

export default withRouter(PANValidationModalSF)


